










import Vue, { VueConstructor } from 'vue'

export default Vue.extend({
  name: 'DdGlobalSearchEmpty',

  props: {
    /**
     * Activate search
     */
    text: {
      type: String,
      default: null,
    },
  },
})
